export const CHECKIN_SUMMARY_PAGE_SOURCE = 'checkin-summary-page'

export const CHECKIN_SUMMARY_PAGE_TRACK_EVENT_NAME =
  '$track_checkin_summary_page_cta_clicked'
